import React, {useState, useEffect} from 'react';

import {NativeStackScreenProps} from '@react-navigation/native-stack';
import DetailSection from './Section';
import HeaderSection from './Header';
import InternalTemplate from '../../../../../components/templates/internal';
import {StackParamList} from '../../../../../navigators';

import {IHistoryDetail} from '../../../../../interfaces/dtos';

type ScreenProps = NativeStackScreenProps<StackParamList, 'HistoryDetail'>;

const HistoryDetailScreen = ({navigation, route}: ScreenProps) => {
  const [detail, setDetail] = useState(null as IHistoryDetail | null);

  useEffect(() => {
    setDetail(route.params);
  }, [route.params]);

  const handleGoBack = () => {
    navigation.navigate('HistoryList');
  };

  if (detail == null) {
    return <></>;
  }

  return (
    <InternalTemplate
      title={'screen-history-detail-title'}
      contentPaddingX="0"
      backButton={{
        label: 'back-history-list',
        onPress: () => handleGoBack(),
        usage: 'external',
      }}>
      <>
        <HeaderSection detail={detail} />
        <DetailSection detail={detail} />
      </>
    </InternalTemplate>
  );
};

export default HistoryDetailScreen;
